import { createRouter, createWebHistory } from "vue-router";
import auth from '../middleware/auth';
import guest from '../middleware/guest';
import admin from "../middleware/admin";
import admin_creator from "../middleware/admin_creator";
import aiFeature from "../middleware/ai_feature";
import { isPublicAuthPath } from "../utils/public-auth-routes";
import {
  getSsoHandoffState,
  shouldRedirectSsoTokenToRoute,
} from "../utils/sso-entry";
import { clearAuthTokens } from "../services/token.service";
import { purgeAuthSessionForPublicAuthPage } from "../services/auth-session.service";
import store from "../store";
import axios from 'axios';
import { getAccessToken } from "../services/token.service";
import { setLoading } from "../store/loadingState.module";

const Landing = () => import("../views/dashboards/Landing.vue");
const Default = () => import("../views/dashboards/Default.vue");
const Automotive = () => import("../views/dashboards/Automotive.vue");
const SmartHome = () => import("../views/dashboards/SmartHome.vue");
const VRDefault = () => import("../views/dashboards/vr/VRDefault.vue");
const VRInfo = () => import("../views/dashboards/vr/VRInfo.vue");
const CRM = () => import("../views/dashboards/CRM.vue");
const Overview = () => import("../views/pages/profile/Overview.vue");
const Teams = () => import("../views/pages/profile/Teams.vue");
const Projects = () => import("../views/pages/profile/Projects.vue");
const General = () => import("../views/pages/projects/General.vue");
const GeneralSearch = () => import("../views/pages/projects/GeneralSearch.vue");
const Timeline = () => import("../views/pages/projects/Timeline.vue");
const NewProject = () => import("../views/pages/projects/NewProject.vue");
const BusinessPlan = () => import("../views/applications/goals/BusinessPlan.vue");
const AgencyPlan = () => import("../views/applications/goals/AgencyPlan.vue");
const Pricing = () => import("../views/pages/Pricing.vue");
const RTL = () => import("../views/pages/Rtl.vue");
const Charts = () => import("../views/pages/Charts.vue");
const SweetAlerts = () => import("../views/pages/SweetAlerts.vue");
const Notifications = () => import("../views/pages/Notifications.vue");
const ListAgenciesPage = () => import("../views/pages/admin/ManageAgencies.vue");
const ListUsersPage = () => import("../views/pages/admin/ManageUsers.vue");
const ManageInvitesPage = () => import("../views/pages/admin/ManageInvites.vue");
const Kanban = () => import("../views/applications/Kanban.vue");
const Wizard = () => import("../views/applications/wizard/Wizard.vue");
const Invite = () => import("../views/applications/invite/Invite.vue");
const AgencySignup = () => import("../views/applications/signup/Agency.vue");
const ManageMembers = () => import("../views/applications/agency/ManageMembers.vue");
const EditStyle = () => import("../views/applications/agency/EditStyle.vue");
const AgencyIntegrations = () => import("../views/applications/agency/Integrations.vue");
const AgencyBilling = () => import("../views/applications/agency/Billing.vue");
const GlossaryPage = () => import("../views/applications/glossary/GlossaryPage.vue");
const GapAnalysis = () => import("../views/applications/glossary/GapAnalysis.vue");
const AiChat = () => import("../views/applications/ai/Chat.vue");
const AiAnalysis = () => import("../views/applications/ai/Analysis.vue");
const AiAnalysisDetail = () => import("../views/applications/ai/AnalysisDetail.vue");
const ReplacementCost = () => import("../views/applications/ai/ReplacementCost.vue");
const FAQs = () => import("../views/pages/FAQs.vue");
const AllProposals = () => import("../views/applications/DataTables.vue");
const Calendar = () => import("../views/applications/Calendar.vue");
const Analytics = () => import("../views/applications/analytics/Analytics.vue");
const EcommerceOverview = () => import("../views/ecommerce/overview/Overview.vue");
const NewProduct = () => import("../views/ecommerce/products/NewProduct.vue");
const EditProduct = () => import("../views/ecommerce/EditProduct.vue");
const ProductPage = () => import("../views/ecommerce/ProductPage.vue");
const ProductsList = () => import("../views/ecommerce/ProductsList.vue");
const OrderDetails = () => import("../views/ecommerce/Orders/OrderDetails");
const OrderList = () => import("../views/ecommerce/Orders/OrderList");
const Referral = () => import("../views/ecommerce/Referral");
const Reports = () => import("../views/pages/Users/Reports.vue");
const NewUser = () => import("../views/pages/Users/NewUser.vue");
const Settings = () => import("../views/pages/Account/Settings.vue");
const Billing = () => import("../views/pages/Account/Billing.vue");
const Invoice = () => import("../views/pages/Account/Invoice.vue");
const Security = () => import("../views/pages/Account/Security.vue");
const Widgets = () => import("../views/pages/Widgets.vue");
const Cover = () => import("../views/auth/signin/Cover.vue");
const Illustration = () => import("../views/auth/signin/Illustration.vue");
const ResetBasic = () => import("../views/auth/reset/Basic.vue");
const ResetCover = () => import("../views/auth/reset/Cover.vue");
const ResetIllustration = () => import("../views/auth/reset/Illustration.vue");
const VerificationBasic = () => import("../views/auth/verification/Basic.vue");
const VerificationCover = () => import("../views/auth/verification/Cover.vue");
const VerificationIllustration = () => import("../views/auth/verification/Illustration.vue");
const SignupBasic = () => import("../views/auth/signup/Basic.vue");
const SignupCover = () => import("../views/auth/signup/Cover.vue");
const SignupIllustration = () => import("../views/auth/signup/Illustration.vue");
const Error404 = () => import("../views/auth/error/Error404.vue");
const Error500 = () => import("../views/auth/error/Error500.vue");
const lockBasic = () => import("../views/auth/lock/Basic.vue");
const lockCover = () => import("../views/auth/lock/Cover.vue");
const lockIllustration = () => import("../views/auth/lock/Illustration.vue");
const Login = () => import("../views/auth/Login.vue");
const Register = () => import("../views/auth/Register.vue");
const ForgotPassword = () => import("../views/auth/ForgotPassword.vue");
const ResetPassword = () => import("../views/auth/ResetPassword.vue");
const UserProfile = () => import("../views/examplesApi/UserProfile/EditUserProfile.vue");
const ListCategoryPage = () => import("../views/examplesApi/CategoryManagement/ListCategoryPage.vue");
const AddCategoryPage = () => import("../views/examplesApi/CategoryManagement/AddCategoryPage.vue");
const EditCategoryPage = () => import("../views/examplesApi/CategoryManagement/EditCategoryPage.vue");
const ListUserPage = () => import("../views/examplesApi/UserManagement/ListUserPage.vue");
const AddUserPage = () => import("../views/examplesApi/UserManagement/AddUserPage.vue");
const EditUserPage = () => import("../views/examplesApi/UserManagement/EditUserPage.vue");
const ListRolePage = () => import("../views/examplesApi/RoleManagement/ListRolePage.vue");
const AddRolePage = () => import("../views/examplesApi/RoleManagement/AddRolePage.vue");
const EditRolePage = () => import("../views/examplesApi/RoleManagement/EditRolePage.vue");
const ListTagPage = () => import("../views/examplesApi/TagManagement/ListTagPage.vue");
const AddTagPage = () => import("../views/examplesApi/TagManagement/AddTagPage.vue");
const EditTagPage = () => import("../views/examplesApi/TagManagement/EditTagPage.vue");
const ListItemPage = () => import("../views/examplesApi/ItemManagement/ListItemPage.vue");
const AddItemPage = () => import("../views/examplesApi/ItemManagement/AddItemPage.vue");
const EditItemPage = () => import("../views/examplesApi/ItemManagement/EditItemPage.vue");
const AgencyLibrary = () => import("../components/AgencyLibrary.vue");
const ReportsEdit = () => import("../components/ReportsEdit.vue");
const ReportView = () => import("../components/ReportView.vue");
const WasmApp = () => import("../components/WasmApp.vue");
const ProtegoApp = () => import("../features/protego/ProtegoApp.vue");
const Sso = () => import("../views/Sso.vue");
const BizassureLinkCallback = () => import("../views/shared/BizassureLinkCallback.vue");

const routes = [
  {
    path: '/sso',
    name: 'sso',
    component: Sso
  },
  {
    path: "/bizassure/link/callback",
    name: "BizAssure Link Callback",
    component: BizassureLinkCallback,
  },
  {
    path: "/report/:sessionId/:hiddenQuestionsIn",
    name: "ReportView",
    component: ReportView,
    props: true, // Pass route parameters as props to the component
  },
  {
    path: "/report-webview/:sessionId/:hiddenQuestionsIn",
    name: "ReportWebview",
    component: ReportsEdit,
    props: true, // Pass route parameters as props to the component
  },
  {
    path: "/library",
    name: "agency_library",
    component: AgencyLibrary
  },
  {
    path: "/protego",
    name: "wasm",
    component: ProtegoApp,
    props: route => ({
      id: Number(route.query.id) || null, // Convert 'id' from the query to a number or set it to null if not present
    }),
  },
  {
    path: '/protego/resume',
    name: 'resume',
    component: ProtegoApp,
    props: { id: -1 } // Pass the default ID as a prop
  },
  {
    path: "/protego-wasm",
    name: "wasm-legacy",
    component: WasmApp,
    props: route => ({
      id: Number(route.query.id) || null,
    }),
  },
  {
    path: "/faq",
    name: "faq",
    component: FAQs
  },
  {
    path: "/",
    name: "/",
    redirect: "/dashboard/home"
  },
  {
    path: "/agencies",
    name: "Agencies",
    component: ListAgenciesPage,
  },
  {
    path: "/goals/business-plan/:user_id?",
    name: "Business Plan",
    component: BusinessPlan,
    props: true,
  },
  {
    path: '/glossary',
    name: 'GlossaryPage',
    component: GlossaryPage,
  },
  {
    path: '/gap-analysis',
    name: 'GapAnalysis',
    component: GapAnalysis,
  },
  {
    path: "/users",
    name: "Users",
    component: ListUsersPage,
  },
  {
    path: "/invites",
    name: "Invites",
    component: ManageInvitesPage,
    meta: {
      middleware: auth
    }
  },
  {
    path: "/style",
    name: "Edit Style",
    component: EditStyle,
    meta: {
      middleware: auth
    }
  },
  {
    path: "/invite",
    name: "Invite",
    component: Invite,
    meta: {
      middleware: auth
    }
  },
  {
    path: "/goals/agency-plan",
    name: "Agency Plan",
    component: AgencyPlan,
    meta: {
      middleware: auth
    }
  },
  {
    path: "/agency/members",
    name: "Agency Members",
    component: ManageMembers,
    meta: {
      middleware: auth
    }
  },
  {
    path: "/agency/integrations",
    name: "Agency Integrations",
    component: AgencyIntegrations,
    meta: {
      middleware: auth
    }
  },
  {
    path: "/agency/billing",
    name: "Agency Billing",
    component: AgencyBilling,
    meta: {
      middleware: auth
    }
  },
  {
    path: "/agency/signup/:token",
    name: "Agency Signup",
    component: AgencySignup,
  },
  {
    path: "/dashboards/dashboard-default",
    name: "DefaultOld",
    component: Default,
    meta: {
      middleware: auth
    }
  },
  {
    path: "/dashboards/landing",
    name: "Landing",
    component: Landing
  },
  {
    path: "/dashboards/automotive",
    name: "Automotive",
    component: Automotive
  },
  {
    path: "/dashboards/smart-home",
    name: "Smart Home",
    component: SmartHome
  },
  {
    path: "/dashboards/vr/vr-default",
    name: "VR Default",
    component: VRDefault
  },
  {
    path: "/dashboards/vr/vr-info",
    name: "VR Info",
    component: VRInfo
  },
  {
    path: "/dashboards/crm",
    name: "CRM",
    component: CRM
  },
  {
    path: "/default", // Main route for the "Default" component
    name: "Default",
    component: Default,
    meta: {
      middleware: auth
    }
  },
  {
    path: "/dashboard/home", // Alias for the "Default" route
    alias: "/default",
    name: "Home",
    component: Default, // Same component as "Default"
    meta: {
      middleware: auth
    }
  },

  {
    path: "/dashboard/overview",
    name: "Metrics",
    component: CRM
  },
  {
    path: "/profile/edit",
    name: "User Profile",
    component: UserProfile,
    meta: {
      middleware: auth
    }
  },
  {
    path: "/examples/role-management/list-roles",
    name: "Role Management",
    component: ListRolePage,
    meta: {
      middleware: [auth, admin]
    }
  },
  {
    path: "/examples/role-management/add-role",
    name: "Add Role",
    component: AddRolePage,
    meta: {
      middleware: [auth, admin]
    }
  },
  {
    path: "/examples/role-management/edit-role/:id",
    name: "Edit Role",
    component: EditRolePage,
    meta: {
      middleware: [auth, admin]
    }
  },
  {
    path: "/examples/user-management/list-users",
    name: "User Management",
    component: ListUserPage,
    meta: {
      middleware: [auth, admin]
    }
  },
  {
    path: "/examples/user-management/add-user",
    name: "User Add",
    component: AddUserPage,
    meta: {
      middleware: [auth, admin]
    }
  },
  {
    path: "/examples/user-management/edit-user/:id",
    name: "Edit User",
    component: EditUserPage,
    meta: {
      middleware: [auth, admin]
    }
  },
  {
    path: "/examples/category-management/list-categories",
    name: "Category Management",
    component: ListCategoryPage,
    meta: {
      middleware: [auth, admin_creator]
    }
  },
  {
    path: "/examples/category-management/add-category",
    name: "Category Add",
    component: AddCategoryPage,
    meta: {
      middleware: [auth, admin_creator]
    }
  },
  {
    path: "/examples/category-management/edit-category/:id",
    name: "Category Edit",
    component: EditCategoryPage,
    meta: {
      middleware: [auth, admin_creator]
    }
  },
  {
    path: "/examples/tag-management/list-tags",
    name: "Tag Management",
    component: ListTagPage,
    meta: {
      middleware: [auth, admin_creator]
    }
  },
  {
    path: "/examples/tag-management/add-tag",
    name: "Add Tag",
    component: AddTagPage,
    meta: {
      middleware: [auth, admin_creator]
    }
  },
  {
    path: "/examples/tag-management/edit-tag/:id",
    name: "Edit Tag",
    component: EditTagPage,
    meta: {
      middleware: [auth, admin_creator]
    }
  },
  {
    path: "/examples/item-management/list-items",
    name: "Item Management",
    component: ListItemPage,
    meta: {
      middleware: [auth, admin_creator]
    }
  },
  {
    path: "/examples/item-management/add-item",
    name: "Add Item",
    component: AddItemPage,
    meta: {
      middleware: [auth, admin_creator]
    }
  },
  {
    path: "/examples/item-management/edit-item/:id",
    name: "Edit Item",
    component: EditItemPage,
    meta: {
      middleware: [auth, admin_creator]
    }
  },
  {
    path: "/pages/profile/overview",
    name: "Profile Overview",
    component: Overview
  },
  {
    path: "/pages/profile/teams",
    name: "Teams",
    component: Teams
  },
  {
    path: "/pages/profile/projects",
    name: "All Projects",
    component: Projects
  },
  {
    path: "/manage/:accountId",
    name: "General",
    component: General,
    props: true
  },
  {
    path: "/manage",
    name: "General Search",
    component: GeneralSearch,
  },
  {
    path: "/pages/projects/timeline",
    name: "Timeline",
    component: Timeline
  },
  {
    path: "/pages/projects/new-project",
    name: "New Project",
    component: NewProject
  },
  {
    path: "/pages/pricing-page",
    name: "Pricing Page",
    component: Pricing
  },
  {
    path: "/pages/rtl-page",
    name: "RTL",
    component: RTL
  },
  {
    path: "/pages/charts",
    name: "Charts",
    component: Charts
  },
  {
    path: "/pages/widgets",
    name: "Widgets",
    component: Widgets
  },
  {
    path: "/pages/sweet-alerts",
    name: "Sweet Alerts",
    component: SweetAlerts
  },
  {
    path: "/pages/notifications",
    name: "Notifications",
    component: Notifications
  },
  {
    path: "/applications/kanban",
    name: "Kanban",
    component: Kanban
  },
  {
    path: "/account/:accountId",
    name: "Account Page",
    component: Kanban,
    props: true
  },
  {
    path: "/applications/wizard",
    name: "Wizard",
    component: Wizard
  },
  {
    path: "/proposals",
    name: "Proposals Table",
    component: AllProposals,
    meta: {
      middleware: auth
    }
  },
  {
    path: "/applications/calendar",
    name: "Calendar",
    component: Calendar
  },
  {
    path: "/applications/analytics",
    name: "Analytics",
    component: Analytics
  },
  {
    path: "/ai/chat",
    name: "AI Chat",
    component: AiChat,
    meta: {
      middleware: [auth, aiFeature("chat")]
    }
  },
  {
    path: "/ai/analysis",
    name: "AI Analysis",
    component: AiAnalysis,
    meta: {
      middleware: [auth, aiFeature("analysis")]
    }
  },
  {
    path: "/ai/analysis/:id",
    name: "AI Analysis View",
    component: AiAnalysisDetail,
    meta: {
      middleware: [auth, aiFeature("analysis")]
    }
  },
  {
    path: "/ai/replacement-cost",
    name: "Replacement Cost Calculator",
    component: ReplacementCost,
    meta: {
      middleware: [auth, aiFeature("replacement_cost")]
    }
  },
  {
    path: "/ecommerce/overview",
    name: "Ecom-Overview",
    component: EcommerceOverview
  },
  {
    path: "/ecommerce/products/new-product",
    name: "New Product",
    component: NewProduct
  },
  {
    path: "/ecommerce/products/edit-product",
    name: "Edit Product",
    component: EditProduct
  },
  {
    path: "/ecommerce/products/product-page",
    name: "Product Page",
    component: ProductPage
  },
  {
    path: "/ecommerce/products/products-list",
    name: "Products List",
    component: ProductsList
  },
  {
    path: "/ecommerce/Orders/order-details",
    name: "Order Details",
    component: OrderDetails
  },
  {
    path: "/ecommerce/Orders/order-list",
    name: "Order List",
    component: OrderList
  },
  {
    path: "/ecommerce/referral",
    name: "Referral",
    component: Referral
  },
  {
    path: "/pages/users/reports",
    name: "Reports",
    component: Reports
  },
  {
    path: "/pages/users/new-user",
    name: "New User",
    component: NewUser
  },
  {
    path: "/pages/account/settings",
    name: "Settings",
    component: Settings
  },
  {
    path: "/pages/account/billing",
    name: "Billing",
    component: Billing
  },
  {
    path: "/pages/account/invoice",
    name: "Invoice",
    component: Invoice
  },
  {
    path: "/pages/account/Security",
    name: "Security",
    component: Security
  },
  {
    path: "/authentication/signin/basic",
    name: "Signin Basic",
    component: Login,
    meta: {
      middleware: guest
    }
  },
  {
    path: "/authentication/signin/cover",
    name: "Signin Cover",
    component: Cover
  },
  {
    path: "/authentication/signin/illustration",
    name: "Signin Illustration",
    component: Illustration
  },
  {
    path: "/authentication/reset/basic",
    name: "Reset Basic",
    component: ResetBasic
  },
  {
    path: "/authentication/reset/cover",
    name: "Reset Cover",
    component: ResetCover
  },
  {
    path: "/authentication/reset/illustration",
    name: "Reset Illustration",
    component: ResetIllustration
  },
  {
    path: "/authentication/lock/basic",
    name: "Lock Basic",
    component: lockBasic
  },
  {
    path: "/authentication/lock/cover",
    name: "Lock Cover",
    component: lockCover
  },
  {
    path: "/authentication/lock/illustration",
    name: "Lock Illustration",
    component: lockIllustration
  },
  {
    path: "/authentication/verification/basic",
    name: "Verification Basic",
    component: VerificationBasic
  },
  {
    path: "/authentication/verification/cover",
    name: "Verification Cover",
    component: VerificationCover
  },
  {
    path: "/authentication/verification/illustration",
    name: "Verification Illustration",
    component: VerificationIllustration
  },
  {
    path: "/authentication/signup/basic",
    name: "Signup Basic",
    component: SignupBasic
  },
  {
    path: "/authentication/signup/cover",
    name: "Signup Cover",
    component: SignupCover
  },
  {
    path: "/authentication/signup/illustration",
    name: "Signup Illustration",
    component: SignupIllustration
  },
  {
    path: "/authentication/error/error404",
    name: "Error Error404",
    component: Error404
  },
  {
    path: "/authentication/error/error500",
    name: "Error Error500",
    component: Error500
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      middleware: guest
    }
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
    meta: {
      middleware: guest
    }
  },
  {
    path: "/password/forgot",
    name: "Forgot Password",
    component: ForgotPassword,

  },
  {
    path: "/password-reset/:token",
    name: "Reset Password",
    component: ResetPassword,
    props: (route) => ({ token: route.params.token, email: route.query.email })

  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  linkActiveClass: "active"
});

// Creates a nextMiddleware() function which not only
// runs the default next() callback but also triggers
// the subsequent Middleware function.
function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index];
  // If no subsequent Middleware exists,
  // the default next() callback is returned.
  if (!subsequentMiddleware)
    return context.next;

  return (...parameters) => {
    // Run the default Vue Router next() callback first.
    context.next(...parameters);
    // Then run the subsequent Middleware with a new
    // nextMiddleware() callback.
    const nextMiddleware = nextFactory(context, middleware, index + 1);
    subsequentMiddleware({ ...context, next: nextMiddleware });
  };
}

router.beforeEach(async (to, from, next) => {
  setLoading(true);

  if (
    to.query?.token
    && shouldRedirectSsoTokenToRoute(to.path, `?token=${String(to.query.token)}`)
  ) {
    return next({
      path: "/sso",
      query: { token: to.query.token },
      replace: true,
    });
  }

  if (isPublicAuthPath(to.path)) {
    const isSsoEntry = to.path === "/sso" && !!to.query?.token;
    const hasActiveHandoff = !!getSsoHandoffState();
    const loginAfterAppLogout = to.path === "/login" && from.path && !isPublicAuthPath(from.path);

    if (isSsoEntry) {
      store.commit("auth/isAuthenticated", false);
    } else if (hasActiveHandoff || loginAfterAppLogout) {
      clearAuthTokens();
      store.commit("auth/isAuthenticated", false);
    } else {
      await purgeAuthSessionForPublicAuthPage();
      store.commit("auth/isAuthenticated", false);
    }
  }

  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware) ? to.meta.middleware : [to.meta.middleware];
    const context = { from, next, to, router };
    const nextMiddleware = nextFactory(context, middleware, 1);

    return middleware[0]({ ...context, next: nextMiddleware });
  }

  return next();
});

router.onError(() => {
  setLoading(false);
});


function showMaintenanceOverlay() {
  if (document.getElementById('maintenance-overlay')) return; // prevent duplicates

  const overlay = document.createElement('div');
  overlay.id = 'maintenance-overlay';
  overlay.style.position = 'fixed';
  overlay.style.top = '0';
  overlay.style.left = '0';
  overlay.style.width = '100vw';
  overlay.style.height = '100vh';
  overlay.style.backgroundColor = 'white';
  overlay.style.zIndex = '9999';
  overlay.style.display = 'flex';
  overlay.style.flexDirection = 'column';
  overlay.style.justifyContent = 'center';
  overlay.style.alignItems = 'center';
  overlay.innerHTML = `
    <div style="text-align: center;">
      <h1 style="font-size: 2.5rem; color: #333;">🚧 Under Maintenance</h1>
      <p style="color: #555; font-size: 1.2rem;">We’ll be back soon. The site is currently undergoing scheduled maintenance.</p>
    </div>
  `;

  document.body.appendChild(overlay);
}


const isPublicAuthRoute = (to) => isPublicAuthPath(to?.path || "");

router.afterEach((to) => {
  setLoading(false);
  const token = getAccessToken();

  if (!token || to.path === '/maintenance' || isPublicAuthRoute(to)) return;

  axios.post(`${process.env.VUE_APP_API_BASE_URL}/ping-activity`, {
    full_path: to.fullPath,
    meta: {
      title: to.meta?.title || '',
      visitedAt: new Date().toISOString(),
    }
  }, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  }).then((res) => {
    if (res.data.maintenance) {
      showMaintenanceOverlay();
    }
  }).catch((err) => {
    console.warn('Route tracking failed:', err);
  });
});



export default router;
